module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/o2kygh/tc-custom/9781439679074.jpg?1717010030370",
      "alt": "This image is the cover for the book Oklahoma's Haunted Route 66, Haunted America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Oklahoma's Haunted Route 66, Haunted America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Trace the haunted heritage of America's Mother Road across Oklahoma.")])]), _c('p', [_vm._v("Route 66 may seem like a quieter thoroughfare than it was in its heyday, but the ghosts of Oklahoma's past bustle along unabated. When the sun sets on the Road of Dreams, the shadows of its roadside attractions take on a nightmarish cast. British airmen disappear into the mist above Miami. Phantoms stir in the Dust Bowl's shallow grave. A westbound Frisco train hops the rails outside Kellyville. Author Tanya McCoy expertly weaves amongst the spirits still traveling along Oklahoma's historic Route 66")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tanya McCoy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Route 66 may seem like a quieter thoroughfare than it was in its heyday, but the ghosts of Oklahoma's past bustle along unabated. When the sun sets on the Road of Dreams, the shadows of its roadside attractions take on a nightmarish cast. British airmen disappear into the mist above Miami. Phantoms stir in the Dust Bowl's shallow grave. A westbound Frisco train hops the rails outside Kellyville. Author Tanya McCoy expertly weaves among the spirits still traveling along Oklahoma's historic Route 66.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0